import "./AboutContentStyles.css";
import React from "react";
import avatar from "../../assets/avatar.png";

const AboutContent = () => {
  const technologies = [
    "React", "Next.js", "TypeScript", "Node.js", "Express", "PostgreSQL", 
    "React Native", "Expo", "Redux", "React Query", "TailwindCSS", "Docker",
    "Firebase", "Framer Motion", "GitHub", "Jira", "Scrum", "Sequelize",
    "N8N", "FastAPI"
  ];

  const softSkills = [
    "Leadership", "Agile Learning", "Creativity", "Critical Thinking", 
    "Effective Communication", "Adaptability", "Teamwork", "Problem Solving",
    "Client Management", "Time Management", "Project Delivery"
  ];

  return (
    <div className="about">
      <div className="about-container">
        {/* Who Am I Section */}
        <div className="about-section">
          <div className="section-header">
            <h1>Who Am I?</h1>
            <div className="underline"></div>
          </div>
          <div className="about-content">
            <div className="about-avatar-section">
              <img 
                src={avatar} 
                alt="Mariano Bozzoletti" 
                className="about-avatar"
              />
            </div>
            <p>
              I'm Mariano Bozzoletti, a Full Stack Developer with FrontEnd orientation 
              focused on developing creative user experiences, paying special attention to details. 
              I specialize in crafting engaging user experiences through modern technologies, 
              combining creative and technical precision to build seamless, high-performance interfaces.
            </p>
          </div>
        </div>

        {/* Skills Section */}
        <div className="skills-section">
          <div className="section-header">
            <h1>My Stack</h1>
            <div className="underline"></div>
          </div>
          
          <div className="skills-container">
            <div className="skill-category">
              <h3>Technologies</h3>
              <div className="skills-grid">
                {technologies.map((tech, index) => (
                  <div key={index} className="skill-item">
                    <span className="skill-text">{tech}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="skill-category">
              <h3>Soft Skills</h3>
              <div className="skills-grid">
                {softSkills.map((skill, index) => (
                  <div key={index} className="skill-item soft-skill">
                    <span className="skill-text">{skill}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <a
            className="btn primary-btn"
            target="_blank"
            href="https://www.dropbox.com/s/5s5lgv8fr0pznhj/Resume%20-%20Mariano%20B.pdf?dl=0"
            rel="noopener noreferrer"
          >
            Download Resume
          </a>
          <button 
            className="btn secondary-btn"
            onClick={() => {
              // Scroll to contact section
              const contactSection = document.querySelector('#contact-section');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Get In Touch
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
